module.exports = __webpack_public_path__ + "static/powerpoint_example_output-d8b7ff812b093d1a81044a51faf1c715.png";